// Rows of weekday chips + start/end times.
import { useTranslation } from 'react-i18next';
import { Plus, Trash2 } from 'lucide-react';

export const DEFAULT_WINDOWS = [
  { days: [0, 1, 2, 3, 4], start: '06:30', end: '08:30' },
  { days: [0, 1, 2, 3, 4], start: '12:30', end: '15:00' },
];

export default function WindowsEditor({ value, onChange, timezone }) {
  const { t } = useTranslation();
  const short = t('parentLink.daysShort', { returnObjects: true }); // ["S","M","T","W","T","F","S"]
  const set = (i, patch) => onChange(value.map((w, j) => (j === i ? { ...w, ...patch } : w)));
  const toggleDay = (i, d) => set(i, { days: value[i].days.includes(d) ? value[i].days.filter((x) => x !== d) : [...value[i].days, d].sort() });
  return (
    <div className="space-y-2">
      <div className="text-xs text-slate-500">{t('parentLink.windowsHint', { timezone })}</div>
      {value.map((w, i) => (
        <div key={i} className="flex flex-wrap items-center gap-2 rounded-xl border border-slate-200 dark:border-slate-700 p-2">
          <div className="flex gap-1">
            {short.map((label, d) => (
              <button type="button" key={d} onClick={() => toggleDay(i, d)}
                className={`w-7 h-7 rounded-full text-xs font-semibold ${w.days.includes(d) ? 'bg-blue-600 text-white' : 'bg-slate-100 dark:bg-slate-800 text-slate-500'}`}>{label}</button>
            ))}
          </div>
          <input type="time" value={w.start} onChange={(e) => set(i, { start: e.target.value })} className="rounded-lg border border-slate-300 dark:border-slate-600 bg-transparent px-2 py-1 text-sm" />
          <span className="text-slate-400">–</span>
          <input type="time" value={w.end} onChange={(e) => set(i, { end: e.target.value })} className="rounded-lg border border-slate-300 dark:border-slate-600 bg-transparent px-2 py-1 text-sm" />
          <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} aria-label={t('common.delete')} className="ms-auto text-slate-400 hover:text-red-500"><Trash2 size={14} /></button>
        </div>
      ))}
      {value.length < 14 && (
        <button type="button" onClick={() => onChange([...value, { days: [0, 1, 2, 3, 4], start: '06:30', end: '08:30' }])} className="inline-flex items-center gap-1 text-xs text-blue-600"><Plus size={12} />{t('parentLink.addWindow')}</button>
      )}
    </div>
  );
}
